import AuthStore from './AuthStore'
import BuildingStore from './BuildingStore'
import ConfigurationStore from './ConfigurationStore'
import ConsumptionStore from './ConsumptionStore'
import EVInvoiceStore from './EVInvoiceStore'
import GasConsumptionStore from './GasConsumptionStore'
import InvoiceStore from './InvoiceStore'
import PaymentMethodStore from './PaymentMethodStore'
import ReceiptStore from './ReceiptStore'
import UserStore from './UserStore'
import WebApplicationStore from './WebApplicationStore'

export default class RootStore {
  AuthStore: AuthStore
  BuildingStore: BuildingStore
  ConfigurationStore: ConfigurationStore
  ConsumptionStore: ConsumptionStore
  EVInvoiceStore: EVInvoiceStore
  GasConsumptionStore: GasConsumptionStore
  InvoiceStore: InvoiceStore
  PaymentMethodStore: PaymentMethodStore
  ReceiptStore: ReceiptStore
  UserStore: UserStore
  WebApplicationStore: WebApplicationStore

  constructor() {
    this.AuthStore = new AuthStore()
    this.BuildingStore = new BuildingStore()
    this.ConfigurationStore = new ConfigurationStore()
    this.ConsumptionStore = new ConsumptionStore()
    this.EVInvoiceStore = new EVInvoiceStore()
    this.GasConsumptionStore = new GasConsumptionStore()
    this.InvoiceStore = new InvoiceStore()
    this.PaymentMethodStore = new PaymentMethodStore()
    this.ReceiptStore = new ReceiptStore()
    this.UserStore = new UserStore()
    this.WebApplicationStore = new WebApplicationStore()
  }
}
